import ajax from '../exports/ajax'
import clientHubLogic from './clientEvents';

const PREFIX = 'error-input-'
const getCurrentUrl = new URL(window.location.href);

$(document).ready(() => {
  login();
  promptFileDownload();
  clientHubLogic();
  jackpotsRedirectFlash();
  changePassword();
  createNewClient();
  resetClient();
  deleteClient();
  scrollToSearchBar();
  positionDropDawnMenu();
  if (document.URL.includes('login')) {
    clearPlaceholderOverlap();
  }

});

function login() {
  $(document).on('click', '#ch_ajax_login', function (e) {
    $('.error') && $('.error').remove();
    e.preventDefault()
    let form = $(this).parents('form'),
      data = form.serializeArray();
    data[data.length] = { name: 'action', value: form.data('action') }
    ajax('POST', data, function (response) {
      if (response.success) {
        window.location.href = response.redirect_url
      }
    }, 'json', null, function (errorResponse) {
      if (errorResponse.responseJSON.data.errors) {
        $.each(errorResponse.responseJSON.data.errors, function (index, value) {
          let el = $('.' + PREFIX + index);
          el.parent().parent().after('<span class="error hide">' + value + '</span>');
        })
        $('.error').each(function (e, val) {
          setTimeout(function () {
            $(val).removeClass('hide');
          }, 1)
        });
      }
    })
  })

  //add enter key compatability
  $(document).on('keyup', '#user_login, #user_pass', function (e) {
    if (e.keyCode === 13) {
      $('#ch_ajax_login').trigger('click');
    }
  })


}

//GRID VIEW

// // Function to check and update the class based on orientation
// function checkOrientation() {
//   var element = document.querySelector('.main-games-ch');

//   // Check if the initial orientation is landscape
//   if (sessionStorage.getItem("grid_filter") !== null && matchMedia('only screen and (max-width: 1025px) and (orientation:portrait)').matches) {
//     element && element.classList.add('thumb', 'landscape');
//    } else {
//       if (sessionStorage.getItem("grid_filter") == null && matchMedia('only screen and (min-width: 1025px)').matches) {
//         element && element.classList.add('list', 'landscape');
//      } 
//    }

//    if (sessionStorage.getItem("grid_filter") == null && matchMedia('only screen and (max-width: 1025px) and (orientation:landscape)').matches) {
//     element && element.classList.add('list', 'landscape');
//    }


//   if (matchMedia('only screen and (min-width: 760px) and (max-width: 849px)').matches) {
//     element && element.classList.add('list');
//   }

// }
// window.addEventListener('load', checkOrientation);

function checkResolution() {
  var element = document.querySelector('.main-nav');

  if (window.innerWidth <= 920) {

    element.classList.remove("flex");
    element.classList.add("webkit-box");

  }
}

// Initial check when the page loads
checkResolution();

// Listen for window resize events
window.addEventListener("load", checkResolution);

//Get a URL from the Learn More button for each game and add an event that opens the url by clicking on the image
const getLearnMoreUrlToImage = () => {
  $(".game-listing-box .bottom.flex a.c-btn-link").each(function () {
    var getUrlLearnMore = $(this).attr('href');
    $(this).parent().parent().parent().children().each(function (index, val) {
      $(val).on("click", $(this), function (e) {
        var target = $(e.target);
        if (target.is('.image-data')) {
          window.location = getUrlLearnMore;
        }
      });
    });
  });
}
getLearnMoreUrlToImage();

document.addEventListener("DOMContentLoaded", function () {

  const toggleText = () => {
    if (document.querySelector('.jp-extra-features-repeater')) {
      document.querySelectorAll('.extra-feature').forEach(function (feature) {
        const textContent = feature.querySelector('.jp-short-info');
        const button = feature.querySelector('.show-more-text');
        const textLength = feature.querySelector('.single-feature-text');
        const swiperWrapper = document.querySelector('.swiper-wrapper');
        const swiperImage = document.querySelector('.swiper-img');
        const boxHeight = 200;
        const textBoxHeight = swiperImage.clientHeight - 100;
        if (textLength && textLength.scrollHeight < boxHeight) {
          button.style.visibility = 'hidden';
        }

        if (window.matchMedia("(max-width: 1025px)").matches) {
          swiperWrapper.style.height = "auto !important";
          textContent.style.height = "auto !important";
          button.style.visibility = 'hidden';

        } else {
          textContent.style.height = textBoxHeight + "px";

        }
        button && button.addEventListener("click", function () {
          textContent && textContent.classList.toggle('expanded');
          if (textContent.classList.contains('expanded')) {
            button.textContent = 'See less';
            swiperWrapper.style.cssText += "height: auto !important";
          } else {
            button.textContent = 'See more';
            swiperWrapper.style.cssText += "height: 205px !important; transition: 0.5s ease";
          }
        });
      });
    }
  };

  toggleText();
});

$("#convert-to-pdf").on("click", function () {
  var ajaxscript = { ajax_url: '/wp-admin/admin-ajax.php' }
  // Use AJAX to trigger the PDF conversion function
  jQuery.ajax({
    type: 'POST',
    url: ajaxscript.ajax_url,
    xhrFields: { responseType: 'blob' },
    data: {
      action: 'convert_html_to_pdf_ajax',
      getVar: 1,
    },
    success: function (response, status, xhr) {
      let filename = xhr.getResponseHeader('Content-Disposition').split('filename=')[1];
      let filenameSplit = filename.split('.');
      console.log(filenameSplit[0]);
      let filenameSplitClear = filenameSplit[0].replace('"', "")
      var blob = new Blob([response]);
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = filenameSplitClear + '.pdf';
      link.click();
    },
  });
});


let timestampArchive;
var loaderOverlayAdd = $('body, .overlay-load.loading.loading-files');
var loaderOverlayIconAdd = $('.custom-loader-load.loading-files');
var loaderOverlayBody = $('body');
var loaderMyPopup = $('#myPopup');
var backgroundLoader = $('.background-loader');
// Function to generate timestampArchive
function generateTimestampArchive() {
  timestampArchive = Date.now() + Math.floor(Math.random() * 50000);
}

// Call the function to generate the initial timestampArchive
generateTimestampArchive();

function fileDownload(element, file) {

  generateTimestampArchive();
  let datas = [];


  //Check for pages recourses and documents
  if (loaderOverlayBody.hasClass('client-branding') || loaderOverlayBody.hasClass('client-document')) {
    loaderOverlayIconAdd.addClass('active');
    loaderOverlayAdd.addClass('active');
    loaderOverlayBody.css('overflow', 'hidden');
  }

  document.querySelectorAll('.accordion-item').forEach(function (item) {
    let gameName = item.querySelector('.documents-heading').innerText;
    gameName = gameName.replaceAll("'", "`");
    
    let checkboxes = item.querySelectorAll('.styled-checkbox:checked');

    // Check if there are any checked checkboxes for the current accordion item
    if (checkboxes.length > 0) {
      let exactIds = Array.from(checkboxes).map(function (checkbox) {
        let id = checkbox.id;
        let number = id.split('-')[0];
        return number;
      });

      datas.push({
        'game_name': gameName,
        'exact_ids': exactIds.join(',')
      });
    }
  });

  var detectDocumentsPage = '';
  if ($('body').hasClass('client-document')) {
    detectDocumentsPage = 'yes';
  } else if ($('body').hasClass('client-branding')) {
    detectDocumentsPage = 'no';
  }

  let data = {
    'action': element.data('action'),
    'file_id': file.length ? file : element.data('file-id'),
    'timestamp': timestampArchive,
    'detect-document-page': detectDocumentsPage,
  };

  datas.forEach(function (game, index) {
    data['game_name[' + index + ']'] = game.game_name;
    data['exact_ids[' + index + ']'] = game.exact_ids;
  });

  ajax('POST', data, function (response) {
    if (response.success === true) {
      if (file.length == 0) {
        let link = document.createElement('a');
        link.href = response.redirect_url;
        link.download = response.file_name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        loaderOverlayIconAdd.removeClass('active');
        loaderOverlayAdd.removeClass('active');
        loaderOverlayBody.css('overflow', 'auto');
      } else {
        loaderOverlayBody.css('overflow', 'hidden');
        backgroundLoader.show();
        setTimeout(() => {
          loaderOverlayIconAdd.addClass('active');
          backgroundLoader.hide();
          loaderMyPopup.removeClass('hide');
          loaderMyPopup.addClass('show');
        }, 1500);

      }

    }
  })
}

function fileDownloadOld(element, file) {
  generateTimestampArchive();
  var data = {
    'action': element.data('action'),
    'file_id': file.length ? file : element.data('file-id'),
    'timestamp': timestampArchive,
  };

  ajax('POST', data, function (response) {
    if (response.success === true) {
      var link = document.createElement('a');
      link.href = response.redirect_url;
      link.download = response.file_name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  })
}

$('.custom-loader-load .close.toggle').click(function() {
  //Popup behavior
  loaderOverlayIconAdd.removeClass('active');
  loaderOverlayAdd.removeClass('active');
  loaderOverlayBody.css('overflow', 'auto');
  loaderMyPopup.removeClass('show');
  loaderMyPopup.addClass('hide');
  backgroundLoader.show();
  
  //Checkbox behavior
  var $styledCheckboxes = $('.accordion.filtred .current_section .styled-checkbox');
  var $selectAllItemsSpan = $('.checkbox_select_all label');
   // Check if all checkboxes are checked or any are unchecked
   $styledCheckboxes.each(function() {
    $styledCheckboxes.prop('checked', false);
    $selectAllItemsSpan.text('Select All Items');
    $('.detect-accordion .checkbox_select_all input').prop('checked', false);
    $('.single-material-row').removeClass('selected');
    $('.custom-file-overlay').removeClass('active');
  });
});

export function promptFileDownload(file = []) {
  if (file.length === 0) {
    $(document).on('click', '.downloadable-file', function () {
      if (!$(this).hasClass('inner-page')) {
        if (($('body').hasClass('client-document') || $('body').hasClass('client-branding')) && file.length !== 0) {
          fileDownload($(this), file);
        } else {
          fileDownloadOld($(this), file);
        }
      }
    })
  } else {
    if (file.length) {
      if ($('body').hasClass('client-document') || $('body').hasClass('client-branding')) {
        fileDownload($('.downloadable-file'), file);
      } else {
        fileDownloadOld($('.downloadable-file'), file);
      }
    }
  }
}

function jackpotsRedirectFlash() {
  $(document).on('click', '.ch-flash-jackpot', function (e) {
    e.preventDefault()
    e.stopImmediatePropagation();
    let data = {
      action: $(this).data('action'),
      cpt: $(this).data('raw-cpt'),
      redirect_url: $(this).data('redirect-url'),
    };

    ajax('POST', data, function (response) {
      if (response.success) {
        window.location.href = response.redirect_url
      }
    })
  })
}

// img to svg
$('img.svg').each(function () {
  var $img = jQuery(this);
  var imgID = $img.attr('id');
  var imgClass = $img.attr('class');
  var imgURL = $img.attr('src');
  $.get(
    imgURL,
    function (data) {
      var $svg = jQuery(data).find('svg');
      if (typeof imgID !== 'undefined') {
        $svg = $svg.attr('id', imgID);
      }
      if (typeof imgClass !== 'undefined') {
        $svg = $svg.attr('class', imgClass + ' replaced-svg');
      }
      $svg = $svg.removeAttr('xmlns:a');
      $img.replaceWith($svg);
    },
    'xml'
  );
});

function animateResult() {
  var interval = setInterval(function () {
    if ($('.filtered-listing-games-wrapper .box:not(.animate)').size() == 0) {
      clearInterval(interval);
    } else {
      $('.filtered-listing-games-wrapper .box:not(.animate)').first().addClass('animate');
    }
  }, 200);
}

function changePassword() {
  $(document).on('click', '.ch-ajax-change-password', function (e) {
    $('.error') && $('.error').remove();
    e.preventDefault()

    let form = $(this).parents('form'),
      data = form.serializeArray();

    ajax('POST', data, function (response) {
      form.find('.success').remove();
      if (response.success) {
        form.find('#password_confirm').parent().parent().after('<span class="success">' + response.message + '</span>');
        $('.overlay.user').addClass('active');
        $('.user-pop--password .client-form-row').removeClass('active');
        $('.user-pop--password .client-form-row input').val('')
        $('body').addClass('active');
      }
    }, 'json', null, function (errorResponse) {
      if (errorResponse.responseJSON.data.errors) {
        $.each(errorResponse.responseJSON.data.errors, function (index, value) {
          let el = $('.' + PREFIX + index);
          el.parent().parent().after('<span class="error hide">' + value + '</span>');
          $('body').addClass('active');
        })
        $('.error').each(function (e, val) {
          setTimeout(function () {
            $(val).removeClass('hide');
          }, 1)
        });
      }
    })
  })
}

function createNewClient() {
  $(document).on('click', '.ch-ajax-create-new-client', function (e) {
    $('.error') && $('.error').remove();
    e.preventDefault()

    let form = $(this).parents('form'),
      data = form.serializeArray();

    ajax('POST', data, function (response) {
      if (response.success) {
        form.parent().find('.success').remove();
        form.parent().find('.filter-wrapper-ch').after('<span class="success">' + response.message + '</span>');
        $('.js-close-pop').click()
      }
    }, 'json', null, function (errorResponse) {
      if (errorResponse.responseJSON.data.errors) {
        form.parent().find('.success').remove();
        $.each(errorResponse.responseJSON.data.errors, function (index, value) {
          let el = $('.' + PREFIX + index);
          el.parent().parent().after('<span class="error hide">' + value + '</span>');
        })
        $('.error').each(function (e, val) {
          setTimeout(function () {
            $(val).removeClass('hide');
          }, 1)
        });
      }
    })
  })
}

function clearPlaceholderOverlap() {

  $(document).on('focus', '#user_login', function () {
    $(this).prop('type', 'email');
  });

  $(document).on('focus', '#user_pass', function () {
    $(this).prop('type', 'password');
  });
}

function resetClient() {
  $(document).on('click', '.ch-ajax-client-reset', function (e) {
    e.preventDefault()

    let clientId = $(this).data('client-id'),
      url = $(this).data('url'),
      data = { action: url, user_id: clientId };

    ajax('POST', data, function (response) {
      if (response.success) {
        console.log(response);
        $('.custom-table-clients').html(response.data.view);
        $('.reset-password-pop,.overlay.user, body').addClass('active');
      }
    }, 'json', null, function (errorResponse) {
      if (errorResponse.responseJSON.data.errors) {
        console.log(errorResponse);
      }
    })
  })
}

function deleteClient() {
  $('.ch-ajax-client-delete').on('click', function (e) {
    e.preventDefault()

    let clientId = $(this).attr('data-client-id'),
      url = $(this).data('url'),
      data = { action: url, user_id: clientId };

    ajax('POST', data, function (response) {
      if (response.success) {
        console.log(response);
        $('.custom-pop,.overlay.user, body').removeClass('active');
        $(`.table-body .row[data-client-id=${clientId}]`).remove();
      }
    }, 'json', null, function (errorResponse) {
      if (errorResponse.responseJSON.data.errors) {
        console.log(errorResponse);
        $('.custom-pop,.overlay.user, body').removeClass('active');
      }
    })
  })
}


//Report games search input script

$(document).one('ready', function () {
  // Handle keyup and keydown events on the search input
  $('#searchInput').on('keyup keydown', function () {
    // Get input value
    var searchInput = $(this).val().toLowerCase();

    // Get the list of titles
    var titles = $('.list-game-urls');


    // Loop through titles to show/hide based on input
    titles.each(function () {
      var title = $(this).children().text().toLowerCase();
      if (title.includes(searchInput)) {
        $(this).show();  // Show matching titles
      } else {
        $(this).hide();  // Hide non-matching titles
      }
    });
  });
});

//If the user start typing in the search bar, the screen will scroll up to the search input
function scrollToSearchBar() {
  if (matchMedia('only screen and (max-width: 849px) and (orientation:landscape)').matches && getCurrentUrl.pathname == '/') {
    const selectors = {
      header: $('#header'),
      input_search: $(".input.filter-search-slot-games"),
    }

    var headerHeight;
    if ($('.admin-bar').length) {
      headerHeight = selectors.header.outerHeight() + 32;
    } else {
      headerHeight = selectors.header.outerHeight();
    }

    const scrollToTop = (selector, pixels) => {
      const element = document.querySelector(selector);

      if (element) {
        element.scrollTo({
          top: pixels !== null ? pixels : 0,
          behavior: 'instant'
        });
      }
    };

    // Debounce function to limit the rate of function calls
    const debounce = (func, delay) => {
      let timeoutId;
      return function () {
        const context = this;
        const args = arguments;
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => func.apply(context, args), delay);
      };
    };

    // Add class on focus and keyup with debouncing
    selectors.input_search.on("click input focus keyup", debounce(function () {
      scrollToTop('html,body', headerHeight);
      if (!$(this).val().trim()) {
        scrollToTop('html,body', headerHeight);
      }
    }, 300));
  }
}

//Add inline CSS on header dropdown calculated with/without admin bar - dropdown menu
function positionDropDawnMenu() {
  if (matchMedia('only screen and (max-width: 849px)').matches && !$('#wpadminbar').length) {
    var isClicked = false;
    var headerHeight;
    $(document).on("click", ".mobile-burger", function () {
      isClicked = !isClicked;
      if (isClicked) {

        $('body').addClass('dropdown_menu');

        if ($('#header').hasClass('sticky')) {
          headerHeight = $('#header').outerHeight() + $('#wpadminbar').outerHeight();
        }

        var scrollTop = $(window).scrollTop();
        scrollTop = scrollTop > 1 ? scrollTop : 0;
        var CopyheaderHeight = $('#header').outerHeight();

        if (scrollTop < 150) {
          var getHeaderScroll = CopyheaderHeight - scrollTop;
        } else {
          getHeaderScroll = headerHeight;
        }

        $('.mobile-nav').css('top', '' + getHeaderScroll + 'px').css('cssText', 'top: ' + getHeaderScroll + 'px !important');
        $('.mobile-nav, #header').css('pointer-events', 'auto');
      } else {
        $('.mobile-nav').removeAttr('style');
        $('body').removeClass('dropdown_menu');
      }

    });
  }
}

function addClassForDevice(width) {
  const element = document.getElementById('games');
  if (window.location.href.indexOf("roadmap") > -1) {
    if (width >= 760) {
      element.classList.add('list');
    } else {
      element.classList.remove('list');
  }
} 
}

function toggleClassBasedOnWidth() {
  const width = window.innerWidth;
  addClassForDevice(width);
}

// Initial check on page load
toggleClassBasedOnWidth();
 // Check on page load
 window.addEventListener('load', toggleClassBasedOnWidth);

 // Check on window resize
 window.addEventListener('resize', toggleClassBasedOnWidth);



// WEBPACK FOOTER //
// ./scripts/components/clientHub.js